import { useState, useEffect } from "react";
import { IonPopover } from "@ionic/react";

// A controlled IonPopover that mounts fresh on open and fully unmounts on
// close, anchored to the click event. Trigger-based popovers would leave
// Ionic's overlay controller in a stuck "presented" state after the first use
// (their dismiss logic grabbed the wrong ion-popover), so the anchor became
// unclickable until reload. Mounting a fresh element per open — the same fix
// used for the admin detail modals — keeps opening reliable; `render` outlives
// `open` briefly so the close still animates.
export default function FreshPopover({ open, event, onClose, children, ...rest }) {
  const [render, setRender] = useState(open);
  useEffect(() => { if (open) setRender(true); }, [open]);
  if (!render) return null;
  return (
    <IonPopover
      isOpen={open}
      event={event}
      onDidDismiss={() => { onClose?.(); setRender(false); }}
      {...rest}
    >
      {children}
    </IonPopover>
  );
}
